import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { fetchPricing } from "./lib/pricing";
import { seedTrialPricing } from "./lib/seedPricing";

// In dev, seed trial pricing from CSV if not already present.
// In all modes, fetch from API (populates localStorage for component use).
seedTrialPricing().then(() => fetchPricing());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
